export default "__VITE_ASSET__B24hNp1U__"